const Info = {
    name : "Kisun(Kartik) sah",
    stack :["Software Developer " , "Full stack developer" , "Competative programmer"],

    Bio:"  Hello! My name is kisun(kartik ) sah  and I am currently pursuing a   Bachelor of Computer Applications (BCA). As an enthusiastic and dedicated student, I am passionate about technology and the  ever-evolving world of software development. In addition to my  academic pursuits, I am a budding Full Stack Developer. This role  allows me to blend my knowledge of front-end and back-end technologies  to create dynamic and responsive web   applications.     "  


}

const ProjectInfo = [
       {
    title: "Ecommerce Application",
    desc :  "An e-commerce application is a digital platform that facilitates the buying and selling of goods and services over the internet. It allows businesses to showcase their products or services, manage transactions, and interact with customers. The main features and functionalities of an e-commerce application  allowing users to fetch data on all available coins, track their prices, and analyze various features." ,
    image:"Eco.png",
    live : true ,
    technologies:[ "frontEnd " ,"Framework ","React js", "node js", "MongoDb " ,"Express js "],
    link : "https://ecomerce001.onrender.com/auth/login",
    github :"https://github.com/kisun-sah/E-Commerce-Application"

 },
 {
    title: "CryptoTracker",
    desc :  "CoinGeckoCrypto Tracker is a comprehensive API service designed to track cryptocurrency prices and features. It offers functionality similar to CoinGecko, allowing users to fetch data on all available coins, track their prices, and analyze various features." ,
    image:"crypto.png",
    live : true ,
    technologies:["React", "npm", "tailwind css" ,"daisyUI"],
    link : "https://crypto-projet-coin-gecko.vercel.app/",
    github :"https://github.com/kisun-sah/Crypto-Projet---CoinGecko"

 },

    {
        title: "HangMan Application ",
        desc : "Hangman is a classic word-guessing game where players try to guess a hidden word by suggesting letters within a limited number of attempts. This project is a modern implementation of the game using the React library.",
        image : "hangman.png",
        live: true ,
        technologies:["React", "npm", "tailwind","daisyUI"],
        link: "https://hang-man-react-brown.vercel.app/",
        github :"https://github.com/kisun-sah/HangMan-React"
    } ,


    {
        title: "Spotify Application ",
        desc :"Sportify is a music streaming application that allows users to create accounts, log in, and enjoy a seamless music experience. The application automatically detects and organizes music files in your device, providing an easy and user-friendly interface similar to Spotify.",
        image : "spotify.png",
        live: true ,
        technologies:["Html ", "Css ", "JavaScript" ,"DOM" ,"Browser"],
        link: "https://vibspotify.freewebhostmost.com/",
        github: "https://github.com/kisun-sah/sportify-Application",
    },

    {
        title : "Tic-Toc-Toe game", 
        desc : "This is a simple Tic-Tac-Toe React game that can be played by two users. The game is built using HTML, CSS, and JavaScript.",
        image : "tiktaktok.png",
        live:true,
        technologies:["javascript","DOM"],
        link:"https://kisun-sah.github.io/Tic-Tac-Toe-game/",
        github:"https://github.com/kisun-sah/Tic-Tac-Toe-React-"
    },

    {
        title:"Lier-List Application" ,
        desc:"This is a drag and drop based tier list app that allows users to create and customize their own tier lists. Users can easily drag and drop items into different tiers, making it convenient to organize and rank various elements.",
        image:"tierlist.png",
        live: false,
        technologies:["Html ", "Css ", "JavaScript" ,"DOM"],
        github:"https://github.com/kisun-sah/Tiar_list-Application"
    },
    {
        title: "Red-Bus Clone ",
        desc: "In this project user has to clone the homepage of the popular website redbus.The homepage of redbus is not responsive by itself as they have seprate mobile web app for it, so if user wants to make it responsive then they have to think about it by their own.",
        image: "redbus.png",
        live:false,
        technologies:["Html ", "Css ", "JavaScript"],
        github :"https://github.com/kisun-sah/full-stack-project/tree/main/03%20Redbus%20Clone"


    } ,

    {
        title : "You-Tube Clone",
        desc:"it is a video play page when you go on this page we will play video  show more disscription on the  video like  like , dslike     saved &  share the video ." ,
        image : "youtube.png",
        live:false,
        github:"https://github.com/kisun-sah/full-stack-project/tree/main/You-Tube%20clone"
                             
    } ,

    // {
    //     title: "Sanke game",
    //     desc:"In this Snake Game, the player controls a snake that moves around the screen, eating food to grow longer. The objective is to make the snake as long as possible without hitting the walls or colliding with its own tail. As the snake eats more food, it becomes faster and more challenging to control.",
    //     image:"snake.png",
    //     live:false,
    //     github:"https://github.com/kisun-sah/JavaScript-Project/tree/main/SnakeGame"
    // }
]

const SkillsInfo = [
   {
      title : "Frontend" ,
      skills : ["HTML" , "CSS" ,"JavaScript" , "React Js" ,"Tailwind CSS" , "BootStrap" ,"Matrial UI" , "TypeScript"]
   },
   {
    title : "Languages" ,
    skills : ["C" , "C++" ,"Java" , "Adv_JavaScript" , "TypeScript" ]
 },



   {
    title : "Backend" ,
    skills : ["Node JS" , "Express JS" ,"MySQL" , "MongoDB" ]
 },


 {
    title : "Tools" ,
    skills : ["Git" , "Github" ,"VS Code" , "MongoDB Compass","Postman" ,"Browser" ,"DSA" ]
 },




]

const ExperienceInfo =  [
    {
        title: " Software Development  " ,
        company:"Emicron Techsolutions Pvt Ltd " ,
        date: "  Jun2024 - Nov 2024  ",
        desc: "During this internship, I gained extensive, hands-on experience in the development and maintenance of web applications, working across both front-end and back-end technologies. This role provided the opportunity to collaborate closely with a team of developers, allowing me to contribute effectively to various stages of the software development lifecycle. Additionally, I was able to apply and refine best practices in full stack development, ensuring that the applications were not only functional but also robust, scalable, and aligned with industry standards."   ,
    
        Skills: ["Html" , "Css" , "javascript ", "React js" , "Node js" ," Mongo DB" , "Express js" , "version control system " ] 
    
        },
     
    {
    title: " Full stack development Industrial Internship   " ,
    company:"EduVersity In collaboration  with Wipro technologies " ,
    date: " Aug2024 - OCT2024  ",
    desc: "During this internship, I gained extensive, hands-on experience in the development and maintenance of web applications, working across both front-end and back-end technologies. This role provided the opportunity to collaborate closely with a team of developers, allowing me to contribute effectively to various stages of the software development lifecycle. Additionally, I was able to apply and refine best practices in full stack development, ensuring that the applications were not only functional but also robust, scalable, and aligned with industry standards."   ,

    Skills: ["Html" , "Css" , "javascript ", "React js" , "Node js" ," Mongo DB" , "Express js" , "version control system " ] 

    },

    {
        title: " Web development  Internship   " ,
        company:"CipherByte Technologies  " ,
        date: " Jun 2024 - Jul 2024  ",
        desc: "This internship significantly enriched my technical expertise in web development by providing in-depth exposure to both front-end and back-end technologies. Through involvement in a diverse range of projects, I was able to hone my skills in crafting dynamic user interfaces as well as developing robust server-side logic. This experience allowed me to bridge the gap between client-side and server-side development, ensuring that I could effectively contribute to the creation of fully integrated web applications that meet industry standards and best practices."   ,
        
        Skills: ["Html" , "Css" , "javascript ", "React js" , "Node js" ," Mongo DB" , "Express js" ] 
    
        },


        {
            title: " Android Application development  " ,
            company:"Engineer Core   " ,
            date: " Jun 2023 - Jul 2023 ",
            desc: "During this internship, I worked on developing and enhancing Android applications using Java and Kotlin. My responsibilities included writing clean, efficient code, debugging issues, and collaborating with the team to design and implement new features. I gained hands-on experience with Android Studio, XML for UI design, and RESTful APIs. This role involved working on real-world projects, contributing to app optimization, and gaining insights into mobile app development best practices."   ,
            
            Skills: ["java" , "XML" , "REST API ", "Andeoid SDK" , "Android Studio" ] 
        
            },
    

        
]

const slugs = [
    "typescript",
    "javascript",
    "dart",
    "java",
    "react",
    "flutter",
    "android",
    "html5",
    "css3",
    "nodedotjs",
    "express",
    "nextdotjs",
    "prisma",
    "amazonaws",
    "postgresql",
    "firebase",
    "nginx",
    "vercel",
    "testinglibrary",
    "jest",
    "cypress",
    "docker",
    "git",
    "jira",
    "github",
    "gitlab",
    "visualstudiocode",
    "androidstudio",
    "sonarqube",
    "figma",
  ];



export {Info ,ProjectInfo ,SkillsInfo ,ExperienceInfo ,slugs}